<template>
  <v-application>
    <v-layout class="ma-2">
      <v-flex v-bind:md6="!large" v-bind:md8="large">
        <v-card class="mb-3">
          <v-toolbar flat>
            <v-toolbar-title>Items</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text @click="markAllReceived">Mark All Received</v-btn>
          </v-toolbar>
          <v-data-table
            v-bind:headers="headers"
            v-bind:items="data.items"
            :items-per-page="200000"
            hide-default-footer
            no-data-text="You have not selected items yet"
            :mobile-breakpoint="0"
          >
            <template v-slot:[`item.name`]="{item}">
              <v-list-item-content>
                <v-list-item-title>{{item.product_name}}</v-list-item-title>
                <v-list-item-subtitle>SKU {{item.sku}}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
            <template v-slot:[`item.to_receive`]="{item}">
              <v-text-field
                type="number"
                v-model.number="item.to_receive"
                reverse
                :ref="'receive'+item.index"
                @focus="$event.target.select()"
                v-bind:rules="[
                v => (v <= item.quality - item.received) || ''
              ]"
              />
            </template>
          </v-data-table>
          <v-data-table
            v-if="data.additional_cost.length > 0"
            v-bind:headers="additional_cost_headers"
            v-bind:items="data.additional_cost"
            :items-per-page="200000"
            hide-default-footer
            :mobile-breakpoint="0"
          >
            <template v-slot:[`item.check`]="{item}">
              <v-checkbox v-model="item.is_received" />
            </template>
            <template v-slot:[`item.amount`]="{item}">{{item.amount.toLocaleString()}}</template>
          </v-data-table>
          <template>
            <v-card-actions>
              <v-spacer />
              <slot name="actions" v-bind:data="data" />
            </v-card-actions>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>

export default {
  name: "v-inventory-receive",
  props: {
    name: String,
    title: String,
    large: Boolean,
  },
  data: () => ({
    headers: [
      { text: "Item", value: "name", width: 300 },
      { text: "Ordered", value: "quality", align: "right" },
      { text: "Received", value: "received", align: "right", width: 100 },
      { text: "To receive", value: "to_receive", align: "right", width: 100 },
    ],
    additional_cost_headers: [
      { text: null, value: "check", width: 20 },
      { text: "Additional cost", value: "name" },
      { text: "Amount", value: "amount", align: "right" },
    ],
    data: {
      is_service_changable: true,
      items: [],
      additional_cost: [],
      total: 0,
    },
  }),
  watch: {
    data: {
      deep: true,
      handler() {
        this.$emit("set-data", this.data);
      },
    },
  },
  mounted() {
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    for (const index in this.additional_cost_headers) {
      this.additional_cost_headers[index]["sortable"] = false;
    }
    this.update();
  },
  methods: {
    async update() {
      const data = this.$communicator.then(
        this,
        await this.$communicator("purchase_by_id", {
          arguments: [this.$route.query["id"], "receive"],
        })
      );
      if (data) {
        for (const index in data.items) {
          data.items[index].to_receive = 0;
          data.items[index].index = index;
        }
        this.data = data;
      }
    },
    markAllReceived() {
      if (this.data) {
        if (typeof this.data.items == typeof []) {
          for (const index in this.data.items) {
            this.data.items[index].to_receive =
              this.data.items[index].quality - this.data.items[index].received;
          }
        }
        if (typeof this.data.additional_cost == typeof []) {
          for (const index in this.data.additional_cost) {
            this.data.additional_cost[index].is_received = true;
          }
        }
      }
    },
  },
};
</script>
